import * as React from 'react';
import * as styles from './styles.css';

import { FormInputsLayout } from '../FormInputsLayout';

export interface IFIOSuggestProps {
  inputValue: string;
  placeholder: React.ReactNode;
  suggestFiltered: React.ReactNode;
  inputRef: React.RefObject<HTMLInputElement> | null;
  onChange(value: string): void;
  onFocus(): void;
}

export function FIOSuggest({
  onChange,
  onFocus,
  inputValue,
  suggestFiltered,
  placeholder,
  inputRef,
}: IFIOSuggestProps) {
  return (
    <>
      <div className={styles['container']}>
        <div className={styles['input-container']}>
          <FormInputsLayout
            InputProps={{
              inputRef,
              value: inputValue,
              onFocus,
              onChange: e => onChange(e.target.value),
            }}
            fullwidth
          />
        </div>
        {placeholder}
        {suggestFiltered}
      </div>
    </>
  );
}
